<template>
    <title>Flood Determination List</title>
    <div class="header">
        <div class="title">
            <h2>60 Day List</h2>
        </div>

        <div class="subtitle">
          <h5 :company="company" :sortCode="sortCode">{{ company }} ({{ sortCode }})</h5>
        </div>
    </div>

    <tw-table :query="query"></tw-table>
</template>

<script>
    import { defineComponent, ref } from 'vue'
    import { useStore } from 'vuex'

    export default defineComponent({
        name: 'ResultsList',
        setup() {
             //Function that all orders from past 60 days
            const store = useStore()
            const company = store.state.user.company
            const sortCode = store.state.user.sortCode
            const query = ref([]);


            (async () => {
                const currentDate = new Date().toLocaleDateString()
                const beginDate = new Date(new Date() - (60*60*24*60*1000)).toLocaleDateString()
                const dateRange = `${beginDate}...${currentDate}`
                query.value = [{
                    "LL_Login_Date": dateRange,
                    "Client": `=="${store.state.user.company}"`
                }]
            })()

            return {
                company, 
                sortCode,  
                query,         
            }
        }
    })
</script>

<style scoped>
</style>